import { render, staticRenderFns } from "./UsageNotification.vue?vue&type=template&id=348e0fca&scoped=true&"
import script from "./UsageNotification.vue?vue&type=script&lang=js&"
export * from "./UsageNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348e0fca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('348e0fca')) {
      api.createRecord('348e0fca', component.options)
    } else {
      api.reload('348e0fca', component.options)
    }
    module.hot.accept("./UsageNotification.vue?vue&type=template&id=348e0fca&scoped=true&", function () {
      api.rerender('348e0fca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/usage/usagenotification/UsageNotification.vue"
export default component.exports